import { render, staticRenderFns } from "./SpaceDashboardCrudMedia.vue?vue&type=template&id=70450cf4&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./SpaceDashboardCrudMedia.vue?vue&type=script&lang=js&"
export * from "./SpaceDashboardCrudMedia.vue?vue&type=script&lang=js&"
import style0 from "./SpaceDashboardCrudMedia.vue?vue&type=style&index=0&id=70450cf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70450cf4",
  null
  
)

export default component.exports